import * as React from "react";
import { connect } from "react-redux";
import FilterableTableContainer from "../Helpers/FilterableTableContainer";
import { ApplicationState } from "../../store";
import * as TenantsStore from "../../store/TenantsReducer";
import { RouteComponentProps } from "react-router";
import ModalContent from "../Modal/ModalContent";
import Popup from "reactjs-popup";
import Button from "../Button";
import { AddIcon, EditIcon, DeleteIcon } from "../../svg";
import i18next from "i18next";

type TenantsProps = TenantsStore.TenantsState &
  typeof TenantsStore.actionCreators &
  RouteComponentProps<{}>;

class ManageDistributors extends React.PureComponent<TenantsProps> {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getAllTenants();
  }

  deleteTenant = (tenantId) => {
    let callback = () => {
      this.props.getAllTenants();
    };
    this.props.deleteTenant(tenantId, callback);
  };

  editTenant = (props) => {
    let tenant = props.record,
      linkTo = "/edit-tenant/" + tenant.id;

    return (
      <>
        <Button
          icon={EditIcon}
          variant="outlined"
          onClick={() => this.props.history.push(linkTo)}
        />
        <Popup
          modal
          trigger={
            <Button icon={DeleteIcon} color="danger" variant="outlined" />
          }
        >
          {(close) => (
            <ModalContent
              close={close}
              type="confirmDeletionModal"
              confirmDelete={() => this.deleteTenant(tenant.id)}
            />
          )}
        </Popup>
      </>
    );
  };

  public render() {
    const { isLoading, tenantsList } = this.props;
    let props = {
      // Data for the table to display; can be anything
      data: tenantsList,
      // Fields to show in the table, and what object properties in the data they bind to
      fields: [
        {
          name: "name",
          displayName: i18next.t("name"),
          inputFilterable: true,
          sortable: true,
        },
        {
          name: "edit",
          displayName: i18next.t("actions"),
          render: this.editTenant,
        },
      ],
      namespace: "People",
      initialSort: "firstName",
      bsLength: 12,
      tableName: i18next.t("tenants"),
    };
    return (
      <div>
        <FilterableTableContainer
          {...{ isLoading }}
          tableProps={props}
          hasActions
          buttons={
            <>
              <Button
                size="large"
                icon={AddIcon}
                onClick={() => this.props.history.push("/add-tenant")}
              >
                {i18next.t("new_user")}
              </Button>
            </>
          }
        />
      </div>
    );
  }
}
export default connect(
  (state: ApplicationState) => state.tenants,
  TenantsStore.actionCreators,
)(ManageDistributors);
